import { Button, cn } from '@renderer/chat'
import { useModals } from '@renderer/components/Modal'
import { Modal, useModalContext } from '../index'
import { useCreateShortcut, useShortcutById, useUpdateShortcut } from '@renderer/chat/hooks/useShortcuts'
import { useEffect, useMemo, useState } from 'react'
import { Input } from '@renderer/windows/components/input'
import { Textarea } from '@renderer/windows/components/textarea'

export const ShortcutEditorModal = () => {
  const { closeModal } = useModals()
  const { context } = useModalContext('shortcut-editor')
  const { data: shortcut } = useShortcutById(context?.shortcut?.id)
  const [name, setName] = useState('')
  const [instructions, setInstructions] = useState('')

  const addShortcutMutation = useCreateShortcut()
  const updateShortcutMutation = useUpdateShortcut()

  const isUpdate = useMemo(() => {
    return !!shortcut?.id
  }, [shortcut])

  const handleContinue = () => {
    if (isUpdate && shortcut?.id) {
      updateShortcutMutation.mutate({
        ...shortcut,
        name,
        prompt: instructions,
      })
    } else {
      addShortcutMutation.mutate({
        name,
        prompt: instructions,
      })
    }

    closeModal('shortcut-editor')
  }

  useEffect(() => {
    if (shortcut) {
      setName(shortcut.name)
      setInstructions(shortcut.prompt)
    }
  }, [shortcut])

  const continueDisabled = useMemo(() => {
    return !name.trim() || !instructions.trim()
  }, [name, instructions])

  return (
    <Modal>
      <Modal.Content>
        <Modal.Header>
          <Modal.Title>Create a new shortcut</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Input>
            <Input.Label>Name</Input.Label>
            <Input.Field placeholder="My new shortcut..." value={name} onChange={(e) => setName(e.target.value)} />
          </Input>

          <Textarea>
            <Textarea.Label>Instructions</Textarea.Label>
            <Textarea.Field
              placeholder="I want you to do the following..."
              value={instructions}
              onChange={(e) => setInstructions(e.target.value)}
            />
          </Textarea>
        </Modal.Body>

        <Modal.Footer className="flex justify-center">
          <Button
            variant="yellow"
            size="large"
            onClick={handleContinue}
            className="max-w-[211px] justify-self-center px-[122px]"
            disabled={continueDisabled}
          >
            Continue
          </Button>
        </Modal.Footer>
      </Modal.Content>
    </Modal>
  )
}
